import axios from 'axios'
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import moment from 'moment'
import store from '@/store'
import Configuration from '@/configuration'
import { router } from '@/router'

export const ACCESS_AUTHENTICATION = 'authentication'
export const ACCESS_LANG = 'lang'
export const ACCESS_FRAME = 'frame'
export const ACCESS_SERVICES = 'services'
export const ACCESS_REMEMBER_CODE = 'remember-code'

export const call = ({access, url, method, ...args}) => new Promise((resolve, reject) => {
  store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_REQUEST_LOADING}`, { }, {root: true})

  try {
    var accessUrl = ''
    if (access === ACCESS_LANG) {
      accessUrl = Configuration.value('API_LANG_URL')
    } else if (access === ACCESS_AUTHENTICATION || ACCESS_REMEMBER_CODE) {
      accessUrl = Configuration.value('API_AUTHENTICATION_URL')
    } else if (access === ACCESS_FRAME) {
      accessUrl = Configuration.value('API_FRAME_URL')
    } else if (access === ACCESS_SERVICES) {
      accessUrl = Configuration.value('API_SERVICES_URL')
    } else {
      reject(new Error('Api Call Access Not Defined'))
    }

    // avoid browser cache
    accessUrl += moment().valueOf() + url

    let requestData = {}
    if (method === 'POST') {
      requestData = {
        requestHeader: getAppRequestHeader()
      }
      if (access !== ACCESS_AUTHENTICATION && access !== ACCESS_REMEMBER_CODE) {
        requestData.requestContent = args.data
      }
    } else if (method === 'GET') {
      requestData = {}
    } else {
      reject(new Error('Api Call Method Not Defined'))
    }

    let userToken = window.localStorage.getItem('user-token')
    let oauthToken = window.localStorage.getItem('oauth-token')
    let authorizationStr = ''
    if (access === ACCESS_AUTHENTICATION) {
      if (userToken && userToken !== '') {
        // Change 'Bearer ' by 'Credentials '
        authorizationStr = 'Credentials ' + userToken.substring('Bearer '.length)
      } else if (oauthToken && oauthToken !== '') {
        authorizationStr = 'Credentials ' + oauthToken
      } else {
        authorizationStr = 'Credentials ' + btoa(JSON.stringify(args.data))
      }
    } else if (access === ACCESS_REMEMBER_CODE) {
      authorizationStr = 'Credentials ' + btoa(JSON.stringify(args.data.username))
      requestData.requestContent = { code: args.data.code, id: args.data.id }
    } else if (access === ACCESS_LANG) {
      authorizationStr = 'Languages 1af9f0404111174d45575350475145475c5053581e500371125a604755477d' // MGP06 codified authorization header
    } else {
      authorizationStr = userToken
    }

    let requestParams = {
      method: method,
      url: accessUrl,
      data: requestData,
      withCredentials: false,
      headers: {
        authorization: authorizationStr
      }
    }

    if (args.blobMode) {
      requestParams.responseType = 'blob'
    }

    resolve(
      axios(requestParams)
        .then(function (response) {
          // Setejar l'user-token al logar-se
          // Refrescar l'user-token al demanar les dades de profile
          if (access === ACCESS_AUTHENTICATION) {
            var token = ''
            if (response.headers.authorization) {
              token = response.headers.authorization
            }
            window.localStorage.setItem('user-token', token)
          }
          store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_SUCCESS}`, { }, {root: true})

          if (args.blobMode) {
            return response
          } else {
            return response.data
          }
        }).catch((error) => {
          // go to login page
          if (access !== ACCESS_AUTHENTICATION && error.response && error.response.status === 401) {
            store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_LOGOUT}`, {removeToken: true}).then(() => {
              router.push('/login').catch(() => {})
              error.response.status = 400
              store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, error)
              store.dispatch(`${appTypes.APP_NAMESPACE}/${appTypes.APP_LOADING}`, false)
            })
          } else {
            throw error
          }
        })
    )
  } catch (err) {
    reject(new Error(err))
  }
})

function getAppRequestHeader () {
  return {
    'acceptLanguage': navigator.language,
    'externalReferer': document.referrer,
    'lang': store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_LANGUAGE}`],
    'referer': document.location.href,
    'userAgent': navigator.userAgent,
    'product': navigator.product,
    'platform': navigator.platform,
    'vendor': navigator.vendor
  }
}



// WEBPACK FOOTER //
// ./src/utils/api.js